import { useCallback, useRef, useState } from 'react';

export const useModal = <T = undefined, R = undefined>() => {
  const [isOpen, setIsOpen] = useState(false);
  const [params, setParams] = useState<T | undefined>(undefined);
  const resolvePromise = useRef<((v: R) => void) | null>(null);

  const open = useCallback((modalParams?: T | undefined) => {
    setIsOpen(true);
    setParams(modalParams);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setParams(undefined);
  }, []);

  const openAndAwaitResponse = useCallback((modalParams?: T | undefined) => {
    setIsOpen(true);
    setParams(modalParams);
    return new Promise<R>((resolve) => {
      resolvePromise.current = resolve;
    });
  }, []);

  const resolveResponse = useCallback((choice: R) => {
    if (resolvePromise.current) {
      resolvePromise.current(choice);
      resolvePromise.current = null;
    }
    setIsOpen(false);
    setParams(undefined);
  }, []);

  return { isOpen, open, close, params, openAndAwaitResponse, resolveResponse };
};
